import { render, staticRenderFns } from "./subOrderStat.vue?vue&type=template&id=7b4a799c&"
import script from "./subOrderStat.vue?vue&type=script&lang=js&"
export * from "./subOrderStat.vue?vue&type=script&lang=js&"
import style0 from "./subOrderStat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports